export default "__VITE_ASSET__DOgMfSoC__"